/* Adds prev/next arrows (and a 1 / N counter) on top of the main product image.
   Works with Dawn's media-gallery: it drives the existing thumbnail buttons
   (which stay in the DOM but are hidden by CSS), and falls back to scrolling
   the slider when no thumbnails exist (e.g. mobile swipe layout). */
(function () {
  function init(gallery) {
    if (gallery.dataset.arrowsReady) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var list = gallery.querySelector('.product__media-list');
    if (!viewer || !list) return;

    var items = list.querySelectorAll('.product__media-item');
    if (items.length < 2) return; // nothing to navigate

    gallery.dataset.arrowsReady = 'true';
    viewer.classList.add('has-gallery-arrows');

    var chevron =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gallery-arrow gallery-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = chevron;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gallery-arrow gallery-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = chevron;

    var counter = document.createElement('div');
    counter.className = 'gallery-counter';
    counter.setAttribute('aria-live', 'polite');

    viewer.appendChild(prev);
    viewer.appendChild(next);
    viewer.appendChild(counter);

    function thumbs() {
      return Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list .thumbnail')
      );
    }

    function currentIndex() {
      var t = thumbs();
      if (t.length) {
        for (var i = 0; i < t.length; i++) {
          if (t[i].getAttribute('aria-current') === 'true') return i;
        }
      }
      // fallback: slide closest to the scroll position
      var w = list.clientWidth || 1;
      return Math.round(list.scrollLeft / w);
    }

    function updateCounter() {
      var total = items.length;
      counter.textContent = currentIndex() + 1 + ' / ' + total;
    }

    function go(dir) {
      var t = thumbs();
      var total = items.length;
      var target = (currentIndex() + dir + total) % total; // loops around
      if (t.length) {
        t[target].click();
      } else {
        list.scrollTo({ left: target * list.clientWidth, behavior: 'smooth' });
      }
      setTimeout(updateCounter, 60);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    // Keyboard: left/right arrows while focus is inside the gallery
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });

    // Keep counter in sync with thumbnails, swipes and variant changes
    var t0 = thumbs();
    if (t0.length && 'MutationObserver' in window) {
      var mo = new MutationObserver(updateCounter);
      t0.forEach(function (b) {
        mo.observe(b, { attributes: true, attributeFilter: ['aria-current'] });
      });
    }
    list.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateCounter);
    }, { passive: true });

    updateCounter();
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-run after theme-editor / section re-renders
  document.addEventListener('shopify:section:load', boot);
})();
